import { Component, OnInit } from '@angular/core';
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';
import { nscModel } from '../../models/nsc/nsc.model';
import * as $ from 'jquery';
import { loginmodel } from '../../models/login/login.model';
import { consumerBasicInfoModel } from '../../models/consumerBasicInfo/consumerBasicInfo.model';
import { Router,ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Rx';

@Component({
	selector: 'app-request-manage',
	templateUrl: './nsc.component.html'
})

export class nscComponent implements OnInit {

	public errorMsg: string = "";
	public successMsg: string = "";
	public sessionData: any;
	public nscModel: nscModel = new nscModel;
	public CreateUserResponseData: any = "";
	public validateOtpResponeData: any = "";
	public serviceOn: boolean = false;
	public consumerBasicInfoModel: consumerBasicInfoModel = new consumerBasicInfoModel;
	public loginmodel: loginmodel = new loginmodel;
	public hideOtp: boolean;
	public hideForm: boolean;
	public hideProceedbtn: boolean;
	public showTranscId: boolean;
	public hideSubmit: boolean;
	public hideTrnsactionID: boolean;
	public transId: string;
	public mbOTP: boolean;
	public isnewApplicntBtn: boolean;
	public paymentNsc: boolean = true;
	public resentMobileOTPData: any;
	public activeResendOtp: boolean = false;
	public isHideBack: boolean;
	public consumerName: string;
	public isHidePrepaid: boolean = true;

	public nscPostData = {
		"id": null,
		"transactionId": null,
		"consumerId": null,
		"firstName": null,
		"lastName": null,
		"blroId": null,
		"mauzaId": null,
		"address1": null,
		"address2": null,
		"address3": null,
		"houseNumber": null,
		"postalCode": null,
		"city": null,
		"suppId": null,
		"catId": null,
		"conId": null,
		"phaseId": null,
		"voltage": null,
		"appliedLoad": null,
		"mobileNumber": null,
		"mobileVerified": null,
		"emailId": null,
		"emailVerified": null,
		"oldPassword": null,
		"newPassword": null,
		"confirmPassword": null,
		"mobileOtp": null,
		"emailOTP": null,
		"otpType": null,
		"createBy": null,
		"createDate": null,
		"updateBy": null,
		"updateDate": null,
		"status": null

	};

	constructor(public http: HttpTestService, public session: sessionServices, public router: Router, private actvRoute: ActivatedRoute) {
		this.hideOtp = false;
		this.hideForm = true;
		this.hideProceedbtn = false;
		this.hideSubmit = true;
		this.hideTrnsactionID = false;
	}

	ngOnInit() {
		this.hideForm = false;
		this.hideSubmit = false;
		this.isHideBack = false;
		this.getSession();
		history.pushState(null, null, location.href);
		window.onpopstate = function () {
			history.go(1);
		};
		this.startTimer();
		//-------Code snippet for chatbot purpose only---------//		
		let enbleNewConct = this.actvRoute.snapshot.paramMap.get('newConnectin') ;
		if(enbleNewConct) this.newApplicant();
		//------------------------------------//
	}

	startTimer = function () {
		var numbers = Observable.timer(45000);
		numbers.subscribe(x => {
			this.activeResendOtp = true;
		});
	}

	//get session details
	getSession = function () {
		this.sessionData = this.session.getSessionDetails();
	}

	back = function () {
		this.hideSubmit = false;
		this.paymentNsc = true;
		this.isHideBack = false;
		this.hideForm = false;
		this.isnewApplicntBtn = false;
	}

	onSelectPayment(selectedID) {
		if (selectedID == 1) {
			this.isHidePrepaid = false;
		} else {
			this.isHidePrepaid = true;
		}
	}

	closePopups() {
		this.loginmodel.paymentMode = "";
		this.isHidePrepaid = true;
	}

	//submitUser
	sendNscReq = function () {
		var self = this;
		this.paymentNsc = false;
		this.hideForm = false;
		this.hideProceedbtn = true;
		this.isHideBack = false;
		self.consumerName = self.consumerBasicInfoModel.firstName;
		//self.serviceOn = true;
		self.nscPostData.firstName = self.consumerBasicInfoModel.firstName;
		self.nscPostData.mobileNumber = self.consumerBasicInfoModel.mobileNumber;
		self.nscPostData.mobileOtp = self.consumerBasicInfoModel.mobileOtp;
		self.nscPostData.transactionId = self.consumerBasicInfoModel.transactionId;

		self.http.postNsc(self.nscPostData).subscribe(
		(data: consumerBasicInfoModel) => {
			self.CreateUserResponseData = data;
			this.transId = self.CreateUserResponseData.transactionId;
			this.mbOTP = self.CreateUserResponseData.mobileOtp;
		},
		(error) => {
			self.errorMsg = error;
		},
		() => {
			self.successMsg = "You have successfully submitted the NSC request.We will contact you soon.";
			self.serviceOn = false;
			self.nscModel.firstName = "";
			self.nscModel.mobileNumber = "";
			//self.nscPostData.mobileOtp ="";
			self.nscPostData.transactionId = "";
			//self.serviceOn = true;
			//	self.otpSend = false;
			self.errorMsg = "";
			self.successMsg = "";
			// var requestedConsumer = self.signUpModel.consumerId;
			//$("#nscForm")[0].reset();
		});
		self.hideOtp = true;
		this.hideSubmit = false;
		//this.router.navigateByUrl('/newNscCompnt');
	}

	sendTranscReq = function () {
		var self = this;
		this.paymentNsc = false;
		document.getElementById('Div1').style.display = 'none';
		document.getElementById('Div2').style.display = 'none';
		// self.router.navigateByUrl('/newNscCompnt');
		self.errorMsg = "";
		self.successMsg = "";

		//var requestedConsumer = ((self.UserBillData.billParam).split("%7C"))[2];
		var requestedConsumer = self.consumerBasicInfoModel.firstName;
		self.nscPostData.transactionId = this.transId;
		self.nscPostData.mobileOtp = self.consumerBasicInfoModel.mobileOtp;
		self.http.postMobileOtpData(self.nscPostData).subscribe(
		(data) => {
			self.validateOtpResponeData = data;
			self.mbOTP = self.validateOtpResponeData;
			if (!self.mbOTP) {
				self.hideTrnsactionID = false;
				document.getElementById('Div1').style.display = 'block';
				document.getElementById('Div2').style.display = 'block';
				self.errorMsg = "Mobile Otp is not valid"
			}else if (self.mbOTP) {
				self.errorMsg = "";
				self.hideTrnsactionID = true;
			}

			// if(self.mbOTP){
			// 	self.hideTrnsactionID = false;
			//  document.getElementById('Div1').style.display = 'block';
			//  document.getElementById('Div2').style.display = 'block';
			//   	self.errorMsg = "Mobile Otp is not valid"
			//   }
			//   else if(!self.mbOTP){
			//   	self.errorMsg = "";
			//   	self.hideTrnsactionID = true;
			//  }
		},
		(error) => {
		},
		() => { });
	}

	resendMobileOTP = function () {
		var self = this;
		self.consumerBasicInfoModel.mobileOtp = null;
		self.http.getResendMobileOTP(this.transId).subscribe(
		(data) => {
			self.resentMobileOTPData = data;
			self.mbOTP = self.resentMobileOTPData;
			if (!self.mbOTP) {
				//self.hideTrnsactionID = false;
				//document.getElementById('Div1').style.display = 'block';
				//document.getElementById('Div2').style.display = 'block';
				self.errorMsg = "Error in resending Mobile Otp"
			}else if (self.mbOTP) {
				self.errorMsg = "";
				self.hideTrnsactionID = false;
				self.activeResendOtp = false;
				self.startTimer();
			}
				//    if(self.mbOTP){
				// 	   self.hideTrnsactionID = false;
				// 	 document.getElementById('Div1').style.display = 'block';
				// 	 document.getElementById('Div2').style.display = 'block';
				// 		 self.errorMsg = "Mobile Otp is not valid"
				// 	 }
				// 	 else if(!self.mbOTP){
				// 		 self.errorMsg = "";
				// 		 self.hideTrnsactionID = true;
				// 	}
		},
		(error) => {

		},
		() => { });
	}

	newApplicant = function () {
		this.paymentNsc = false;
		this.hideForm = true;
		this.hideSubmit = true;
		this.isHideBack = true;
		this.isnewApplicntBtn = true;
	}

	showTransc = function () {
		var self = this;
		this.paymentNsc = false;
		self.errorMsg = "";
		this.router.navigate(['/newNscRegCompnt', this.transId], { skipLocationChange: true });
	}

	paymentForNsc = function () {
		this.paymentNsc = false;
		this.isHideBack = false;
		var self = this;
		self.router.navigateByUrl('/paymentNsc');
	}
}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/nsc/nsc.component.ts